



























import { Component, Prop, Vue } from 'vue-property-decorator'
import { Element } from '@/models'
import { CV_VALUE_ELEMENT_RELATION_TYPE } from '@/utils/constants'
import { CvValueUtils } from '@/utils/cv-value-utils'

@Component({
  components: {}
})
export default class RelationToListInfo extends Vue {
  @Prop({ required: true, type: Object }) readonly element: Element
  private CV_VALUE_ELEMENT_RELATION_TYPE = CV_VALUE_ELEMENT_RELATION_TYPE

  private isLoaded = false

  get parentNameComponent() {
    return this.$parent.$options.name
  }

  async mounted() {
    await this.loadRelationType()
    this.isLoaded = true
  }

  async loadRelationType() {
    await CvValueUtils.getCvValuesByType(CV_VALUE_ELEMENT_RELATION_TYPE)
  }
}
